import { DeleteIcon, EditIcon } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import { ButtonGroup, ButtonGroupItem } from '#components/patterns/button-group/ButtonGroup.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import type { Host } from '#dn-types/host.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import styles from './HostButtons.module.css';

type Props = {
  host: Host;
  onDeleteClick: () => void;
  onBlockClick: () => void;
  onUnblockClick: () => void;
};

export function HostButtons({ host, onDeleteClick, onBlockClick, onUnblockClick }: Props) {
  const location = useAppLocation();

  const menu = (
    <>
      {host.isBlocked ?
        <MenuItem onClick={onUnblockClick}>Unblock</MenuItem>
      : <>
          <MenuItem render={<Link to="debug" state={{ from: location }} />}>Debug</MenuItem>
          <MenuItem onClick={onBlockClick}>Block</MenuItem>
          {host.endpointOIDCUserID ? null : (
            <MenuItem render={<Link to={'enroll'} state={{ from: location }} />}>Enroll</MenuItem>
          )}
        </>
      }
    </>
  );

  return (
    <ButtonGroup>
      <ButtonGroupItem>
        <Tooltip
          content="Edit"
          render={<LinkButton size="small" variant="icon" to="edit?tab=general" state={{ from: location }} />}
        >
          <EditIcon aria-hidden="true" />
          <span className="visually-hidden">Edit</span>
        </Tooltip>
      </ButtonGroupItem>
      <ButtonGroupItem>
        <Tooltip content="Delete" render={<Button size="small" variant="icon" onClick={onDeleteClick} />}>
          <DeleteIcon aria-hidden="true" />
          <span className="visually-hidden">Delete</span>
        </Tooltip>
      </ButtonGroupItem>
      <ButtonGroupItem>
        <Tooltip
          className="height-fit-content"
          content="More"
          render={
            <MeatballMenu
              className={styles.HostButtons_moreMenuPopover}
              menuButtonVariant="minimal"
              render={<Button className="width-100" size="small" variant="icon" />}
              gutter={8}
            />
          }
        >
          {menu}
        </Tooltip>
      </ButtonGroupItem>
    </ButtonGroup>
  );
}
